import tippy from 'tippy.js';
import { hideAll } from 'tippy.js';

/**
 * Attach popup to content in page
 *
 * @param {HTMLLinkElement} trigger - The link which opens the popup
 * @param {HTMLFigureElement} target - Element containing the content to display
 */
export function attachReferencePopup(trigger, target) {
  if (target) {
    let contentHTML;
    let popupModifier;

    if (trigger.classList.contains('reference-link--figure')) {
      popupModifier = 'primary';
      contentHTML = target.outerHTML; // Capture the figure element
    } else if (trigger.classList.contains('reference-link--numerical')) {
      popupModifier = 'inverse';
      contentHTML = target.innerHTML; // Capture the contents of the li
    }

    tippy(trigger, {
      allowHTML: true,
      trigger: 'click',
      maxWidth: 696, // 664 + padding on tippy-content
      arrow: false,
      offset: [20, -8],
      content: `
        <div class="popup popup--${popupModifier}">
          ${contentHTML}
        </div>`,
      interactive: true, // For clickable images
      onShow(instance) {
        hideAll({ exclude: instance });
      },
    });
  }

  // Prevent links jumping to anchors
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
  });
}

/**
 * Attach popup to the "cite" button
 *
 * @param {HTMLLinkElement} trigger - The button which opens the popup
 */
export function attachCitePopup(trigger) {
  if (!trigger) return;

  tippy(trigger, {
    allowHTML: true,
    trigger: 'click',
    maxWidth: 696, // 664 + padding on tippy-content
    arrow: false,
    offset: [20, -8],
    content: `
    <div class="popup popup--primary">
      <h2 class="h3">Cite this page</h2>
      <div class="copy-to-clipboard-node">"${trigger.dataset.pageTitle}" <em>${trigger.dataset.siteTitle}</em>, ${trigger.dataset.siteSponsor}, ${trigger.dataset.datePublished}, ${trigger.dataset.pageUrl}.</div>
      <button type="button" class="button button--standard copy-to-clipboard-button gap-top-m-1">
        Copy to clipboard
      </button>
    </div>
    `,
    interactive: true,
    onShow(instance) {
      hideAll({ exclude: instance });
    },
  });
}

/**
 * Attach popup to the "share" button
 *
 * @param {HTMLLinkElement} trigger - The button which opens the popup
 */
export function attachSharePopup(trigger) {
  if (!trigger) return;

  const encodedTitle = encodeURIComponent(trigger.dataset.pageTitle);
  const encodedUrl = encodeURI(window.location.href);

  tippy(trigger, {
    allowHTML: true,
    trigger: 'click',
    maxWidth: 696, // 664 + padding on tippy-content
    arrow: false,
    offset: [20, -8],
    content: `
    <div class="popup popup--primary">
      <h2 class="h3">Share this page</h2>
      <div class="popup__button-group">
        <button type="button" class="button button--standard copy-to-clipboard-button gap-top-m-1" data-copy-text="${window.location.href}">
          Copy link
        </button>
        <a href="https://www.facebook.com/sharer.php?u=${encodedUrl}" target="_blank" class="button button--standard">Facebook</a>
        <a href="https://www.twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}" target="_blank" class="button button--standard">Twitter</a>
        <a href="mailto:?subject=${encodedTitle}&body=${encodedUrl}" class="button button--standard">Email</a>
      </div>
    </div>
    `,
    interactive: true,
    onShow(instance) {
      hideAll({ exclude: instance });
    },
  });
}

export default document.addEventListener('DOMContentLoaded', () => {
  const refEls = document.querySelectorAll('.reference-link');
  refEls.forEach((refEl) => {
    const target = document.querySelector(refEl.hash);
    attachReferencePopup(refEl, target);
  });
  attachCitePopup(document.querySelector('#cite-button'));
  attachSharePopup(document.querySelector('#share-button'));
});
